import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Coin from './Coin';

function CoinList() {
  const [coins, setCoins] = useState([]);
  const [search, setSearch] = useState('');

  const coingecko_url = 'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&per_page=250&order=market_cap_desc';

  useEffect(() => {
    axios.get(coingecko_url)
      .then(res => {
        setCoins(res.data);
        console.log(res.data);
      })
      .catch(error => console.log(error));
  }, []);

  const handleChange = e => {
    setSearch(e.target.value);
  };

  const filteredCoins = coins.filter(coin =>
    coin.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className='coin-app'>
      <div className='coin-search'>
        <h1>Search crypto</h1>
        <form>
          <input
            className='coin-input'
            type='text'
            onChange={handleChange}
            placeholder='Search'
          />
        </form>
      </div>
      <div className='table-header'>
          <p className='coin-name'>Name</p>
          <p className='coin-price'>Asset price</p>
          <p className='coin-marketcap'>Market cap</p>
          <p className='coin-change'>Change (24h)</p>
          <p className='coin-volume'>Volume (24h)</p>
      </div>
      <div className='coin-table section-wrapper'>
      {filteredCoins.map(coin => {
        return (
          <Coin
            rank={coin.market_cap_rank}
            key={coin.id}
            name={coin.name}
            price={coin.current_price.toLocaleString("en-US", {style:"currency", currency:"USD", maximumFractionDigits: 10})}
            symbol={coin.symbol}
            marketcap={coin.market_cap.toLocaleString("en-US", {style:"currency", currency:"USD", maximumFractionDigits: 0})}
            volume={coin.total_volume.toLocaleString("en-US", {style:"currency", currency:"USD", maximumFractionDigits: 0})}
            image={coin.image}
            priceChange={coin.price_change_percentage_24h}
          />
        );
      })}
      </div>
    </div>
  );
}

export default CoinList;